import axios from 'axios'
import { env } from '@/env'
const buildingLinkServerURL = env.VUE_APP_NODE_SERVER_BLK
const subscriptionKey = env.VUE_APP_SUBSCRIPTION_KEY
//const communicationNodeServerURL = env.VUE_APP_communicationNodeServerURL
export const state = {
  serviceSuperAdmin: [],
}

export const getters = {
  getServiceSuperAdmin: (state) => {
    return state.serviceSuperAdmin
  },
}

export const mutations = {
  SET_SUPER_ADMIN_SERVICES(state, serviceList) {
    console.log('set superAdmin', serviceList)
    state.serviceSuperAdmin = serviceList
  },
}

export const actions = {
  async BuildingAnalysisReportingAPI({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}BuildingAnalysisAsync(buildingName='${
          data.buildingName
        }',getUnmapped=1,pageSize=100,skipRecords=${
          data.recordAvailable
        },dateFilterFrom=${data.start},dateFilterTo=${data.end})`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      throw error
    }
  },
  async VendorRatingAnalysisAsyncReportingAPI(
    { commit, state, rootState },
    data
  ) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}VendorRatingAnalysisAsync(vendorName='${
          data.vendorName
        }',status=0,ratingStatus=0,pageSize=100,skipRecords=${
          data.recordAvailable
        },dateFilterFrom=${data.start},dateFilterTo=${data.end})`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      throw error
    }
  },
  async buildingRatingAnalysisReportingAPI({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}BuildingRatingAnalysisAsync(searchKeyword='${
          data.SearchKeyword
        }',status=0,ratingStatus=0,buildingId=${
          data.buildingId
        },pageSize=100,skipRecords=${data.recordAvailable},dateFilterFrom=${
          data.start
        },dateFilterTo=${data.end})`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      throw error
    }
  },
  async InquiryAnalysisAsyncfunction({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}InquiryAnalysisAsync(customerName='${
          data.inquiryName
        }',pageSize=100,skipRecords=${data.recordAvailable},dateFilterFrom=${
          data.start
        },dateFilterTo=${data.end})`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      throw error
    }
  },
  async getAllServicesAsyncfunction({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceFormForAdminAsync(searchKeyword='${
          data.serviceName
        }',sortingBy='${data.sorting}',providerStatus=${
          data.providerStatus
        },pageSize=100,skipRecords=${data.recordAvailable})`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      throw error
    }
  },

  async DeletionOfVendorServicesFunction({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}DeletionOfVendorServices(serviceFormId=${
          data.Id
        })`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      throw error
    }
  },

  async getallVendorUserList({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}GetVendorUsers(vendorId=${data.Id})`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      throw error
    }
  },

  async VendorAnalysisAsyncReportingAPI({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}VendorAnalysisAsync(vendorName='${
          data.vendorName
        }',status=0,pageSize=100,skipRecords=${
          data.recordAvailable
        },dateFilterFrom=${data.start},dateFilterTo=${data.end})`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      throw error
    }
  },
  async CategoryAnalysisAsyncReportingAPI({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}CategoryAnalysisAsync(categoryName='${
          data.categoryName
        }',serviceCountBit=1,pageSize=100,skipRecords=${
          data.recordAvailable
        },dateFilterFrom=${data.start},dateFilterTo=${data.end})`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      throw error
    }
  },
  async ServiceAnalysisAsyncReportingAPI({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceAnalysisAsync(serviceName='${
          data.serviceName
        }',inquiryCountBit=1,pageSize=100,skipRecords=${
          data.recordAvailable
        },dateFilterFrom=${data.start},dateFilterTo=${data.end})`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      throw error
    }
  },
  async InquiryAnalysisAsyncReportingAPI({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}InquiryAnalysisAsync(customerName='${
          data.inquiryName
        }',pageSize=100,skipRecords=${data.recordAvailable},dateFilterFrom=${
          data.start
        },dateFilterTo=${data.end})`,
      })
      const responseData = getDetails.data.value
      return responseData
    } catch (error) {
      throw error
    }
  },
  async AddNYCBuildingDistribution({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}AddNYCBuildingDistribution(serviceFormId=${data},serviceReferenceId=1448)`,
      })
      const responseData = getDetails.data
      console.log('responseData', responseData)
      return responseData
    } catch (error) {
      throw error
    }
  },

  async upadteAllServiceForSequenceOrder_BLK(
    { commit, state, rootState },
    data
  ) {
    try {
      var updatedResponce = await axios({
        method: 'patch',
        url: `${buildingLinkServerURL}ServiceRequestForms(${
          data.ServiceRequestFormId
        })`,
        data: { SequenceNumber: data.SequenceNumber },
      })
      return updatedResponce
    } catch (error) {
      throw error
    }
  },
  async deleteImagesFromProviderMedia_BLK({ commit, state, rootState }, data) {
    try {
      var deleteresponse = await axios({
        method: 'delete',
        url: `${buildingLinkServerURL}ProviderMedias(${data.Id})`,
      })
      const responseData = deleteresponse
      return responseData
    } catch (error) {
      console.log('TCL: deleteImagesFromProviderMedia_BLK', error)
      throw error
    }
  },
  async addImagestoProviderMedia_BLK({ commit, state, rootState }, data) {
    try {
      var addResponse = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}ProviderMedias`,
        data: data,
      })
      const responseData = addResponse
      return responseData
    } catch (error) {
      console.log('TCL: addImagestoService_BLK', error)
      throw error
    }
  },
  async deleteCategoryFromProviderCategoryMappings_BLK(
    { commit, state, rootState },
    data
  ) {
    try {
      var deleteresponse = await axios({
        method: 'delete',
        url: `${buildingLinkServerURL}ProviderCategoryMappings(${data.Id})`,
      })
      const responseData = deleteresponse
      return responseData
    } catch (error) {
      console.log('TCL: deleteCategoryFromProviderCategoryMappings_BLK', error)
      throw error
    }
  },
  async removeBuildingFromTable_BLK({ commit, state, rootState }, data) {
    try {
      var deleteresponse = await axios({
        method: 'delete',
        url: `${buildingLinkServerURL}ServiceRequestFormFacilityLinks(${data})`,
      })
      const responseData = deleteresponse
      return responseData
    } catch (error) {
      console.log('TCL: removeBuildingFromTable', error)
      throw error
    }
  },
  async addcategorytoProviderCategoryMappings_BLK(
    { commit, state, rootState },
    data
  ) {
    try {
      var addResponse = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}ProviderCategoryMappings`,
        data: data,
      })
      const responseData = addResponse
      return responseData
    } catch (error) {
      console.log('TCL: addImagestoService_BLK', error)
      throw error
    }
  },
  async getVendorDetailsByUserId_BLK({ commit, state, rootState }, data) {
    console.log('in getVendorDetailsByUserId_BLK', data)
    try {
      const getDetails = await axios({
        method: 'get',
        // url: `${buildingLinkServerURL}Providers(ProviderId=${data})?$select=ProviderId,ProviderName,ProviderPhone,ProviderEmail,Provideraboutus,Provideraddress,IsActive,Providerzip&$expand=ProviderStatus,ProviderCategoryMappings`,

        url: `${buildingLinkServerURL}Providers(ProviderId=${data})?$select=StripeAccountID,ProviderId,ProviderName,ProviderPhone,ProviderEmail,Provideraboutus,Provideraddress,IsActive,Providerzip&$expand=ProviderStatus,ProviderMedias,ProviderCategoryMappings,ServiceRequestForms($expand=ServiceRequestFormEnquiries($select=Id))`,

        headers: {
          auth: `${rootState.auth.authToken}`,
        },
      })
      const responseData = getDetails.data
      console.log(
        'TCL: getVendorDetailsByUserId_BLK -> responseData',
        responseData
      )
      return responseData
    } catch (error) {
      console.log('TCL: getVendorDetailsByUserId_BLK -> error', error)
      throw error
    }
  },

  async phoneValidator_BLK({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}Providers?$filter=ProviderPhone eq '${data}'`,
      })
      const responseData = getDetails.data
      console.log('responseData', responseData)
      return responseData
    } catch (error) {
      console.log('TCL: phoneValidator_BLK -> error', error)
      throw error
    }
  },
  async getServiceRequestId({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequests?$filter=ServiceRequestFormEnquiryId eq ${data}`,
      })
      return getDetails.data.value
    } catch (error) {
      throw error
    }
  },
  async GetRequestContactDetailsByServiceRequestId(
    { commit, state, rootState },
    data
  ) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}GetRequestContactDetailsByServiceRequestId(serviceRequestId=${data})`,
      })
      return getDetails.data.value
    } catch (error) {
      throw error
    }
  },
  async emailValidator_BLK({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}Providers?$filter=ProviderEmail eq '${data}'`,
      })
      const responseData = getDetails.data
      console.log('responseData', responseData)
      return responseData
    } catch (error) {
      console.log('TCL: emailValidator_BLK -> error', error)
      throw error
    }
  },
  async companyValidator_BLK({ commit, state, rootState }, data) {
    try {
      const getDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}Providers?$filter=ProviderName eq '${data}'`,
      })
      const responseData = getDetails.data
      console.log('responseData', responseData)
      return responseData
    } catch (error) {
      console.log('TCL: companyValidator_BLK -> error', error)
      throw error
    }
  },

  async activateDeactivateVendor_BLK({ commit, state, rootState }, data) {
    console.log('data', data)
    try {
      const postAdminServices = await axios({
        method: 'patch',
        url: `${buildingLinkServerURL}Providers(${data.id})`,
        data: data.data,
        headers: {
          auth: `${rootState.auth.authToken}`,
        },
      })
      const responseData = postAdminServices
      console.log('responseData', responseData)
      console.log(
        'TCL: activateDeactivateVendor_BLk -> responseData',
        responseData
      )

      return responseData
    } catch (error) {
      console.log('TCL: activateDeactivateVendor_BLK -> error', error)
      throw error
    }
  },
  async getNoficationCount_BLK({ commit, state, rootState }, data) {
    try {
      const getNotificationCount = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}getNotificationCount`,
        //communicationNodeServerURL + '/api/v1.0/user/getNotificationCount',
        data: data,
      })

      const responseData = getNotificationCount
      console.log('responseData', responseData)

      return responseData
    } catch (error) {
      throw error
    }
  },

  // async activateDeactivateVendor_BLK({ commit, state, rootState }, data) {
  //   console.log('data', data)
  //   try {
  //     const postAdminServices = await axios({
  //       method: 'patch',
  //       url: `${buildingLinkServerURL}Providers(${data.id})`,
  //       data: data.data,
  //       headers: {
  //         auth: `${rootState.auth.authToken}`,
  //       },
  //     })
  //     const responseData = postAdminServices
  //     console.log('responseData', responseData)
  //     console.log(
  //       'TCL: activateDeactivateVendor_BLk -> responseData',
  //       responseData
  //     )

  //     return responseData
  //   } catch (error) {
  //     console.log('TCL: activateDeactivateVendor_BLK -> error', error)
  //     throw error
  //   }
  // },

  async getallservicesforsuperadmin({ commit, state, rootState }, data) {
    try {
      const getServices = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestForms?$count=true&$top=12&$skip=${
          data.recordAvailable
        }&$orderby=ServiceRequestFormCreateDate desc&$expand=ServiceRequestFormsImages($select=ImageUrl),ServiceRequestFormCategory,Provider($select=ProviderId,ProviderName,ProviderEmail)&$filter=Provider/SandOStatus eq 1`,
      })

      const responseData = getServices.data
      return responseData
    } catch (error) {
      console.log('TCL: getAllService -> error', error)
      throw error
    }
  },

  async getAllVendorCategory_BLK({ commit, state, rootState }, data) {
    try {
      const getServicesCategory = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}/ProviderCategories?$skip=${
          data.skip
        }&$select=Id,Name&$filter=IsActive eq true`,
      })
      const responseData = getServicesCategory.data.value
      console.log('responseData', responseData)
      console.log('TCL: getAllVendorCategory_BLK -> responseData', responseData)
      return responseData
    } catch (error) {
      console.log('TCL: getAllVendorCategory_BLK -> error', error)
      throw error
    }
  },

  async getAllProvidersForSuperAdmin_BLK({ commit, state, rootState }) {
    console.log('in getAllProvidersForSuperAdmin_BLK')
    try {
      const getServicesDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}Providers?$orderby=ProviderId desc &$filter=SandOStatus eq 1&$select=ProviderId,ProviderName`,
      })
      const responseData = getServicesDetails.data.value
      console.log(
        'getAllProvidersForSuperAdmin_BLK -> responseData',
        responseData
      )
      if (!responseData.length) {
        console.log('getAllProvidersForSuperAdmin_BLK -> Invalid data receive')
        throw new Error('Invalid data received')
      }
      return responseData
    } catch (error) {
      console.log('TCL: getAllProvidersForSuperAdmin_BLK -> error', error)
      throw error
    }
  },
  async getAllProvidersForSuperAdminForSearch_BLK(
    { commit, state, rootState },
    data
  ) {
    console.log('in getAllProvidersForSuperAdminForSearch_BLK')
    try {
      const getServicesDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}Providers?$orderby=ProviderName&$filter=contains(ProviderName,'${
          data.ProviderName
        }') and SandOStatus eq 1 &$select=ProviderId,ProviderName`,
      })
      const responseData = getServicesDetails.data.value
      console.log(
        'getAllProvidersForSuperAdminForSearch_BLK -> responseData',
        responseData
      )
      return responseData
    } catch (error) {
      console.log('TCL: getAllProvidersForSuperAdmin_BLK -> error', error)
      throw error
    }
  },
  async getListOfAllVendorForSandoAdmin_BLK(
    { commit, state, rootState },
    data
  ) {
    console.log('In getListOfAllVendorForSandoAdmin_BLK')
    try {
      //  2 for activate vendors 1 for pending
      var flag = data.flagForDeactivateVendor ? 3 : null
      console.log('data.flagForDeactivateVendor', data.flagForDeactivateVendor)

      const getServicesDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}Providers?$filter=SandOStatus ne ${flag} &$skip=${
          data.recordAvailable
        }&$orderby=ProviderId desc&$select=ProviderId,ProviderName,ProviderPhone,ProviderEmail,IsActive,SandOStatus &$expand=ProviderCategoryMappings($select=Id),ProviderMedias($select=Id),ServiceRequestForms($expand=ServiceRequestFormEnquiries($count=true))`,

        // url: `${buildingLinkServerURL}Providers?$filter=SandOStatus ne ${flag} &$skip=${
        //   data.recordAvailable
        // }&$orderby=ProviderId desc&$select=ProviderId,ProviderName,ProviderPhone,ProviderEmail,IsActive,SandOStatus &$expand=ProviderCategoryMappings($select=Id),ServiceRequestForms($expand=ServiceRequestFormEnquiries($select=Id))`,
      })
      const responseData = getServicesDetails.data.value
      console.log(
        'TCL: getListOfAllVendorForSandoAdmin_BLK -> responseData',
        responseData
      )
      const allVendors = responseData
      return allVendors
    } catch (error) {
      console.log('TCL: getListOfAllVendorForSandoAdmin_BLK -> error', error)
      throw error
    }
  },

  async getListOfAllFacility({ commit, state, rootState }, data) {
    try {
      const getFacilityDetails = await axios({
        method: 'get',

        url: `${buildingLinkServerURL}GetBuildingDistributionlistAsync(pageSize=100,skipRecords=${
          data.recordAvailable
        },getUnmapped=${data.Unmappedflag})`,
        // url: `${buildingLinkServerURL}Facilities?&$skip=${
        //   data.recordAvailable
        // }&$expand=ServiceRequestFormFacilityLinks($expand=ServiceRequestForm($expand=ServiceRequestFormEnquiries($count=true)))&$filter=ServiceRequestFormFacilityLinks/any(c: c/ServiceRequestFormFacilityLinkFacId gt 0)`,

        // url: `${buildingLinkServerURL}Providers?$filter=SandOStatus ne ${flag} &$skip=${
        //   data.recordAvailable
        // }&$orderby=ProviderId desc&$select=ProviderId,ProviderName,ProviderPhone,ProviderEmail,IsActive,SandOStatus &$expand=ProviderCategoryMappings($select=Id),ServiceRequestForms($expand=ServiceRequestFormEnquiries($select=Id))`,
      })
      const responseData = getFacilityDetails.data.value
      console.log('TCL: getFacilityDetails -> responseData', responseData)
      const allVendors = responseData
      return allVendors
    } catch (error) {
      console.log('TCL: getFacilityDetails -> error', error)
      throw error
    }
  },
  async getListofVendorFromBuildingLink({ commit, state, rootState }, data) {
    try {
      const getVendorList = await axios({
        method: 'get',

        url: `${buildingLinkServerURL}GetListOfServiceRequestFormMarginByVendors?pageSize=100&skipRecords=${
          data.recordAvailable
        }&providerName=${data.providerName}`,
      })
      return getVendorList.data.value
    } catch (error) {
      throw error
    }
  },
  // Get list of all services for margin set
  async getListOfServicesForMargin_BuildingLink(
    { commit, state, rootState },
    data
  ) {
    try {
      const getFacilityDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}GetListofServiceRequestFormMargin?ProviderId=0&skipRecords=${
          data.recordAvailable
        }&pageSize=100&searchKeyword=${data.searchKeyword}`,
      })
      return getFacilityDetails.data.value
    } catch (error) {
      throw error
    }
  },
  // Get all orders for admin
  async GetAllOrderList({ commit, state, rootState }, data) {
    try {
      const getFacilityDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}GetAllOrderList?pageSize=100&skipRecords=${
          data.recordAvailable
        }&searchKeyword=${data.searchKeyword}`,
      })

      return getFacilityDetails.data.value
    } catch (error) {
      throw error
    }
  },
  // GetListofPayout for admin
  async GetListofPayout({ commit, state, rootState }, data) {
    try {
      const getFacilityDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}GetVendorPayoutListAsync?pageSize=100&skipRecords=${
          data.recordAvailable
        }&searchKeyword=${data.searchKeyword}`,
      })

      return getFacilityDetails.data.value
    } catch (error) {
      throw error
    }
  },
  // Get Milestones
  async getMilestoneInformationFromBuildingLink(
    { commit, state, rootState },
    data
  ) {
    try {
      const getFacilityDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestMilestones?$filter=servicerequestid eq ${
          data.serviceRequestId
        }`,
      })

      return getFacilityDetails.data.value
    } catch (error) {
      throw error
    }
  },
  // Get getPayoutInformationFromBuildingLink
  async getPayoutInformationFromBuildingLink(
    { commit, state, rootState },
    data
  ) {
    try {
      console.log('in payout history')
      console.log(data)
      const getFacilityDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestProviderPayouts?$expand=Provider&$filter=ProviderId eq ${
          data.ProviderId
        }`,
        // url: `${buildingLinkServerURL}ServiceRequestProviderPayouts?$expand=Provider&$filter=ProviderId eq ${
        //   data.ProviderId
        // } and (contains( PayoutId,'${
        //   data.searchKeyword
        // }') or contains( StripePayoutId,'${
        //   data.searchKeyword
        // }') or contains( PayoutAmount,'${data.searchKeyword}'))`,
      })
      console.log('res :', getFacilityDetails.data)
      return getFacilityDetails.data.value
    } catch (error) {
      throw error
    }
  },
  // Get Refund Details
  async ServiceRequestMilestoneRefunds({ commit, state, rootState }, data) {
    try {
      const getFacilityDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestMilestoneRefunds?$filter=ServiceRequestId  eq ${
          data.serviceRequestId
        }&$expand=ServiceRequestRefundFiles`,
      })

      return getFacilityDetails.data.value
    } catch (error) {
      throw error
    }
  },
  // Update Margin for services

  async setMarginForService({ commit, state, rootState }, data) {
    try {
      const getFacilityDetails = await axios({
        method: 'POST',
        url: `${buildingLinkServerURL}SaveMarginforSelectedServiceRequestForms`,
        data,
      })

      return getFacilityDetails.data.value
    } catch (error) {
      throw error
    }
  },
  // Update Margin for Vendor

  async setMarginForVendor({ commit, state, rootState }, data) {
    try {
      const getFacilityDetails = await axios({
        method: 'POST',
        url: `${buildingLinkServerURL}SaveMarginForServiceRequestFormsByVendors`,
        data,
      })

      return getFacilityDetails.data.value
    } catch (error) {
      throw error
    }
  },
  // Update Admin response

  async ServiceRequestRefundApproveRejectByAdmin(
    { commit, state, rootState },
    data
  ) {
    try {
      const getFacilityDetails = await axios({
        method: 'POST',
        url: `${buildingLinkServerURL}ServiceRequestRefundApproveRejectByAdmin`,
        data,
      })

      return getFacilityDetails.data.value
    } catch (error) {
      throw error
    }
  },
  // Get Buildings information by Search Functionality
  async searchingBuildingFromSandoDatabase({ commit, state, rootState }, data) {
    try {
      const getFacilityDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}GetBuildingDistributionlistAsync(buildingName='${
          data.buildingName
        }',pageSize=100,skipRecords=${data.recordAvailable},getUnmapped=${
          data.Unmappedflag
        })`,
        // url: `${buildingLinkServerURL}Facilities?&$skip=${
        //   data.recordAvailable
        // }&$filter=contains(FacName ,'${
        //   data.buildingName
        // }') &$expand=ServiceRequestFormFacilityLinks($expand=ServiceRequestForm($expand=ServiceRequestFormEnquiries($count=true)))`,
      })
      const responseData = getFacilityDetails.data.value

      return responseData
    } catch (error) {
      throw error
    }
  },

  async getListOfAllInquiries_BLK({ commit, state, rootState }, data) {
    try {
      const getServicesDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestFormEnquiries?$skip=${
          data.recordAvailable
        }&$orderby=Id desc&$expand=CreateUser($expand=Facility),ServiceRequestForm($expand=Provider($select=ProviderName,ProviderEmail,ProviderPhone),ServiceRequests($select=ServiceRequestId))`,
      })

      const responseData = getServicesDetails.data.value
      console.log('responseData', responseData)

      const allVendors = responseData
      return allVendors
    } catch (error) {
      throw error
    }
  },

  async getListOfAllBuildings_BLK({ commit, state, rootState }, data) {
    try {
      const getServicesDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}Facilities?$skip=${
          data.recordAvailable
        }&$expand=ServiceRequestFormFacilityLinks($expand=ServiceRequestForm($expand=ServiceRequestFormEnquiries))`,
      })

      const responseData = getServicesDetails.data.value
      console.log('responseData', responseData)

      const allVendors = responseData
      return allVendors
    } catch (error) {
      throw error
    }
  },

  // Get All Facilities Master Data
  async getListOfAllFacilities_BLK({ commit, state, rootState }, data) {
    try {
      const getServicesDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}Facilities?$filter=IsActive eq true`,
      })

      const responseData = getServicesDetails.data.value
      const allVendors = responseData
      return allVendors
    } catch (error) {
      throw error
    }
  },

  // Get All Facilities Master Data
  async getListOfAllserviceform_BLK({ commit, state, rootState }, data) {
    try {
      const getServicesformDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestForms?$count=true&$skip=${
          data.recordAvailable
        }&$expand=ServiceRequestFormFacilityLinks&$filter=Provider/SandOStatus eq 1 and ServiceRequestFormFacilityLinks/all(c:c/ServiceRequestFormFacilityLinkFacId ne ${
          data.selectedBuildingID
        })&$orderby=ServiceRequestFormId desc`,
      })

      const responseData = getServicesformDetails.data.value
      const allVendors = responseData
      return allVendors
    } catch (error) {
      throw error
    }
  },
  // get services by building
  async loadSearchedServicesFromBuilding_BLK(
    { commit, state, rootState },
    data
  ) {
    try {
      const getServicesformDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestForms?$skip=${
          data.recordAvailable
        }&$filter=Provider/SandOStatus eq 1 and contains(ServiceRequestFormName,'${
          data.searchValue
        }') and ServiceRequestFormFacilityLinks/all(c: c/ServiceRequestFormFacilityLinkFacId ne ${
          data.selectedBuildingID
        })&$orderby=ServiceRequestFormId desc`,
      })

      const responseData = getServicesformDetails.data.value
      const allVendors = responseData
      return allVendors
    } catch (error) {
      throw error
    }
  },
  // Get All selected Buildings
  async getListOfAllSelected_BLK({ commit, state, rootState }, data) {
    try {
      const getServicesDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestFormFacilityLinks?$count=true&$skip=${
          data.recordAvailable
        }&$filter=ServiceRequestFormFacilityLinkFormId eq ${
          data.serviceID
        }&$expand=Facility($select=Name)`,
      })

      const responseData = getServicesDetails.data
      return responseData
    } catch (error) {
      throw error
    }
  },

  // Get All selected serviceForm
  async getListOfAllSelected_serviceForm_BLK(
    { commit, state, rootState },
    data
  ) {
    try {
      const getSelectedServicesDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestForms?$count=true&$skip=${
          data.recordAvailable
        }&$expand=ServiceRequestFormFacilityLinks($filter=ServiceRequestFormFacilityLinkFacId eq ${
          data.selectedBuildingID
        })&$filter=Provider/SandOStatus eq 1 and ServiceRequestFormFacilityLinks/any(c: c/ServiceRequestFormFacilityLinkFacId eq ${
          data.selectedBuildingID
        })&$orderby=ServiceRequestFormId desc`,
      })

      return getSelectedServicesDetails
    } catch (error) {
      throw error
    }
  },
  // Search  Facilities in Master Data
  async loadSearchedFacilities_BLK({ commit, state, rootState }, data) {
    try {
      const getServicesDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}Facilities?$filter=contains(Name,'${
          data.searchValue
        }') and IsActive eq true`,
      })
      const responseData = getServicesDetails.data.value

      const allVendors = responseData
      return allVendors
    } catch (error) {
      throw error
    }
  },
  // Search  Facilities in Master Data
  async loadSearchedFacilitiesForReport_BLK(
    { commit, state, rootState },
    data
  ) {
    try {
      const getServicesDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}Facilities?$filter=contains(Name,'${
          data.searchValue
        }') and IsActive eq true&$select=Name,FacId`,
      })
      const responseData = getServicesDetails.data.value

      const allVendors = responseData
      return allVendors
    } catch (error) {
      throw error
    }
  },
  async deleteEnquiries_BLK({ commit, state, rootState }, data) {
    console.log('In getListOfAllEnquiries_BLK')
    try {
      const getServicesDetails = await axios({
        //   method: 'get',
        //   url: `${buildingLinkServerURL}Providers?$skip=${
        //     data.recordAvailable
        //   }&$orderby=ProviderId desc&$select=ProviderId,ProviderName,ProviderPhone,ProviderEmail,IsActive&$expand=ProviderStatus`,
        // })
        method: 'delete',
        url: `${buildingLinkServerURL}/ServiceRequestFormEnquiries(${
          data.data
        })`,
      })

      const responseData = getServicesDetails.data.value
      console.log('responseData', responseData)

      const allVendors = responseData
      return allVendors
    } catch (error) {
      console.log('TCL: getListOfAllEnquiries_BLK -> error', error)
      throw error
    }
  },

  async deleteVendor_BLK({ commit, state, rootState }, data) {
    console.log('In deleteVendor_BLK')
    try {
      const getServicesDetails = await axios({
        method: 'delete',
        url: `${buildingLinkServerURL}/Providers(${data.providerID})`,
      })

      const responseData = getServicesDetails
      console.log('responseData', responseData)

      const allVendors = responseData
      return allVendors
    } catch (error) {
      console.log('TCL: deleteVendor_BLK -> error', error)
      throw error
    }
  },
  async loadSearchedEnquiry_BLK({ commit, state, rootState }, data) {
    try {
      const getServicesDetails = await axios({
        method: 'get',

        url: `${buildingLinkServerURL}ServiceRequestFormEnquiries?$skip=${
          data.recordAvailable
        }&$filter=contains( Message ,'${data.searchValue}') or contains(Name,'${
          data.searchValue
        }' ) or contains(Phone,'${
          data.searchValue
        }' )or contains(ServiceRequestForm/ServiceRequestFormName,'${
          data.searchValue
        }' )or contains(ServiceRequestForm/Provider/ProviderName,'${
          data.searchValue
        }' )&$orderby=Id desc&$expand=CreateUser($expand=Facility),ServiceRequestForm($expand=Provider ($select=ProviderName,ProviderEmail,ProviderPhone))`,
      })
      const responseData = getServicesDetails.data.value
      const allVendors = responseData
      return allVendors
    } catch (error) {
      throw error
    }
  },

  async loadSearchedBuildings_BLK({ commit, state, rootState }, data) {
    try {
      const getServicesDetails = await axios({
        method: 'get',

        url: `${buildingLinkServerURL}Facilities?$skip=${
          data.recordAvailable
        }&$filter=contains( FacName ,'${
          data.searchValue
        }')&orderby=CreateDate desc&$expand=ServiceRequestFormFacilityLinks($expand=ServiceRequestForm($expand=ServiceRequestFormEnquiries))`,
      })

      const responseData = getServicesDetails.data.value
      console.log('responseData', responseData)

      const allVendors = responseData
      return allVendors
    } catch (error) {
      throw error
    }
  },

  async loadVendor_BLK({ commit, state, rootState }, data) {
    console.log('In loadVendor_BLK')
    try {
      const getServicesDetails = await axios({
        method: 'get',
        // url: `${buildingLinkServerURL}Providers(${
        //   data.vendorId
        // })?&$select=ProviderId&$expand=ProviderCategoryMappings($select=Id),ServiceRequestForms($expand=ServiceRequestFormsImages($select=Id),ServiceRequestFormFacilityLinks($select=ServiceRequestFormFacilityLinkId),ServiceRequestFormEnquiries($select=Id),)`,

        url: `${buildingLinkServerURL}Providers(${
          data.vendorId
        })?&$select=ProviderId&$expand=ProviderCategoryMappings($select=Id),ProviderMedias($select=Id),ServiceRequestForms($expand=ServiceRequestFormsImages($select=Id),ServiceRequestFormFacilityLinks($select=ServiceRequestFormFacilityLinkId),ServiceRequestFormEnquiries($select=Id),ServiceRequestFormPrompts($expand=ServiceRequestFormPromptChoices),ServiceRequestFormOptions)`,
      })
      const responseData = getServicesDetails.data
      console.log('responseData', responseData)

      console.log('TCL: loadVendor_BLK -> responseData', responseData)
      const allVendors = responseData
      return allVendors
    } catch (error) {
      console.log('TCL: loadVendor_BLK -> error', error)
      throw error
    }
  },
  async loadSearchedVendor_BLK({ commit, state, rootState }, data) {
    console.log('In loadSearchedVendor_BLK')
    try {
      var flag = data.flagForDeactivateVendor ? 3 : null

      const getServicesDetails = await axios({
        method: 'get',
        // url: `${buildingLinkServerURL}Providers?$filter=(contains(ProviderName,'${
        //   data.vendorName
        // }'))and SandOStatus ne ${flag}&$skip=${
        //   data.recordAvailable
        // }&$orderby=ProviderId desc&$select=ProviderId,ProviderName,ProviderPhone,ProviderEmail,IsActive,SandOStatus&$expand=ProviderCategoryMappings($select=Id),ServiceRequestForms($expand=ServiceRequestFormEnquiries($select=Id))`,

        url: `${buildingLinkServerURL}Providers?$filter=(contains(ProviderName,'${
          data.vendorName
        }'))and SandOStatus ne ${flag}&$skip=${
          data.recordAvailable
        }&$orderby=ProviderId desc&$select=StripeAccountID,ProviderId,ProviderName,ProviderPhone,ProviderEmail,IsActive,SandOStatus&$expand=ProviderCategoryMappings($select=Id),ProviderMedias($select=Id),ServiceRequestForms($expand=ServiceRequestFormEnquiries($count=true))`,
      })
      const responseData = getServicesDetails.data.value
      console.log('responseData', responseData)

      console.log('TCL: loadSearchedVendor_BLK -> responseData', responseData)
      const allVendors = responseData
      return allVendors
    } catch (error) {
      console.log('TCL: getListOfAllVendorForSandoAdmin_BLK -> error', error)
      throw error
    }
  },
  async getAllservicesBybuildingId_BLK({ commit, state, rootState }, data) {
    try {
      const geserviceDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestForms?$orderby=ServiceRequestFormCreateDate desc&$skip=${
          data.recordAvailable
        }&$select=ServiceRequestFormId,ServiceRequestFormProviderId,ServiceRequestFormName,ServiceRequestFormCreateDate&$expand=ServiceRequestFormFacilityLinks($select=ServiceRequestFormFacilityLinkId),Provider($select=ProviderId,ProviderName)`,
        headers: {
          'Ocp-Apim-Subscription-Key': subscriptionKey,
          'content-type': 'application/json',
        },
      })
      const responseData = geserviceDetails.data.value
      console.log(
        'getAllservicesBybuildingId_BLK : responseData :',
        responseData
      )
      // if (geserviceDetails.data.status.code) {
      //   throw new Error('Invalid data received')
      // }
      return responseData
    } catch (error) {
      console.log('getAllservices', error)
      throw error
    }
  },

  async loadSearchedService_BLK({ commit, state, rootState }, data) {
    try {
      const geserviceDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}ServiceRequestForms?$filter=contains(ServiceRequestFormName,'${
          data.serviceName
        }') or contains(Provider/ProviderName,'${data.serviceName}')&$skip=${
          data.recordAvailable
        }&$orderby=ServiceRequestFormCreateDate desc&$select=ServiceRequestFormId,ServiceRequestFormProviderId,ServiceRequestFormName,ServiceRequestFormCreateDate&$expand=ServiceRequestFormFacilityLinks($select=ServiceRequestFormFacilityLinkId),Provider($select=ProviderId,ProviderName)`,
      })
      const responseData = geserviceDetails.data.value
      console.log(
        'getAllservicesBybuildingId_BLK : responseData :',
        responseData
      )
      // if (geserviceDetails.data.status.code) {
      //   throw new Error('Invalid data received')
      // }
      return responseData
    } catch (error) {
      console.log('getAllservices', error)
      throw error
    }
  },

  async getbuildingsinfobyIdBLK({ commit, state, rootState }, data) {
    try {
      const geserviceDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}/ServiceRequestFormFacilityLinks?$filter=ServiceRequestFormFacilityLinkFormId eq ${data}`,
      })
      const responseData = geserviceDetails.data.value
      console.log(
        'getAllservicesBybuildingId_BLK : responseData :',
        responseData
      )
      // if (geserviceDetails.data.status.code) {
      //   throw new Error('Invalid data received')
      // }
      return responseData
    } catch (error) {
      console.log('getAllservices', error)
      throw error
    }
  },

  async getbuildingsinfobyFacIdBLK({ commit, state, rootState }, data) {
    try {
      const geserviceDetails = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}/ServiceRequestFormFacilityLinks?$filter=ServiceRequestFormFacilityLinkFacId eq ${data}`,
      })
      const responseData = geserviceDetails.data.value
      console.log(
        'getAllservicesBybuildingId_BLK : responseData :',
        responseData
      )
      // if (geserviceDetails.data.status.code) {
      //   throw new Error('Invalid data received')
      // }
      return responseData
    } catch (error) {
      console.log('getAllservices', error)
      throw error
    }
  },

  async addBuildingstoService_BLK({ commit, state, rootState }, data) {
    try {
      var addResponse = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}ServiceRequestFormFacilityLinks`,
        data: data,
      })
      const responseData = addResponse
      return responseData
    } catch (error) {
      console.log('TCL: addImagestoService_BLK', error)
      throw error
    }
  },
  async adminMarginSettings({ commit, state, rootState }, data) {
    try {
      const getStatus = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}SaveMarginforAllServiceRequestForms`,
        data: data,
      })
      const responseData = getStatus
      return responseData
    } catch (error) {
      console.log('TCL: ProviderCompanyCreate -> error', error)
      throw error
    }
  },
  async sendPaymentToVendor({ commit, state, rootState }, data) {
    try {
      const getStatus = await axios({
        method: 'post',
        url: `${buildingLinkServerURL}TransferVendorPayoutToStripeAccount?vendorId=${
          data.vendorId
        }&vendorStripeAccount=${data.vendorStripeAccount}&Amount=${
          data.Amount
        }`,
      })
      const responseData = getStatus
      return responseData
    } catch (error) {
      throw error
    }
  },
  async disableSandoAsync({ commit, state, rootState }, data) {
    console.log(data)
    console.log('in disable mode')
    try {
      const responseBL = await axios({
        method: 'get',
        url: `${buildingLinkServerURL}DisableSando?facId=${
          data.FacID
        }&enableSando=${Number(data.SandOStatus)}`,
      })
      const responseData = responseBL
      return responseData
    } catch (error) {
      console.log('TCL: disable/enable sando error', error)
      throw error
    }
  },
}
